// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"dffe4c71","198":"0ca6d20e","328":"18136a63","655":"b486f2d3","845":"1535cb7d","869":"9b06b3d5","890":"60d4fc30","953":"18136a63"}[chunkId] + ".chunk.css";
};